import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputOneTimePasswordComponent } from './input-one-time-password.component';

@NgModule({
  declarations: [InputOneTimePasswordComponent],
  imports: [CommonModule],
  exports: [InputOneTimePasswordComponent],
})
export class OtpInputModule {}
